import { useParams, useNavigate } from "react-router-dom";
import EvaluationReport from "./EvaluationReport";

const EvaluatorReportPage = () => {
    const { paperId, sheetId } = useParams();
    const navigate = useNavigate();

    // We don't strictly need to fetch the paper here if EvaluationReport handles mostly sheet data.
    // But if we want to ensure context or breadcrumbs... 
    // For now EvaluationReport takes sheetId and onBack.

    const handleBack = () => {
        navigate(`/evaluator/${paperId}`);
    };

    if (!sheetId) return <div>Invalid Sheet ID</div>;

    return (
        <div className="h-screen w-full bg-muted/20 overflow-hidden flex flex-col">
            <EvaluationReport
                sheetId={sheetId}
                onBack={handleBack}
            />
        </div>
    );
};

export default EvaluatorReportPage;
